import {
  ColorVariant,
  theme,
} from "@/components/canvas-editor/components/Container";
import { cn } from "@/lib/utils";

export function ColorPreview({ color }: { color: ColorVariant }) {
  return (
    <div
      className={cn(
        `w-4 h-4 rounded`,
        theme.preview[color === "slate" ? "default" : color],
      )}
    />
  );
}
